export const entity = {
    name: 'LiberalityExpenseCategory',
    facets: ['codeName'],
    fields: [
        {path: 'name', unique: true},
        {path: 'active', type: 'boolean'}
    ],
    filters: [
        {
            name: 'active',
            isDefault: false,
            query: () => ({ active: true })
        }
    ]
}


export const module_ = {
    object: 'LiberalityExpenseCategory',
    tKey: 'Catégorie de dépense',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    viewMap: {
        dt: [
            {path: 'code'},
            {path: 'name'},
            'active'
        ],
        form: [
            {path: 'code'},
            {path: 'name'},
            {path: 'active', type: 'booleanToggle'},
        ]
    }
}
